export default __webpack_public_path__ + "static/media/card4-1920x1080Tiny.9df980a7.png";